import { Icon } from '@atoms/index';
import TagListRenderer from '@legacy/core/renderers/TagListRenderer';
import { UserAvatarStack } from '@molecules/index';
import { getPriorityIcon } from '@utils/priority';
import ObjectListCard from '../../core/components/ObjectListCard';
import AlertingRenderer from "../../core/renderers/AlertingRenderer";
import DateTimeRenderer from "../../core/renderers/DateTimeRenderer";
import StatusChipRenderer from '../../core/renderers/StatusChipRenderer';
import { getJobStatusChipLabel, getJobStatusColorClass } from '../utils/utils';


function JobListCard(props) {
    const { data, showState } = props
    const job = data

    const footerContext = {
        label: null,
        value: null
    }

    footerContext.label = "Scheduled For:"
    footerContext.value = footerContext.value = (
        <AlertingRenderer alertCondition={job.state_label === "Scheduled" && job.is_past_due}>
            <DateTimeRenderer type="datetime" value={job.start_time} options={{duration: job.duration, addYear: true}} />
        </AlertingRenderer>
    )

    return <ObjectListCard
        objectName="Job"
        objectID={job.custom_id || job.id}
        priorityIcon={(
            <Icon
                icon={getPriorityIcon(job.priority)}
                size={8}
                containerClassName={job.priority === 1 ? "text-alerting" : ""}
            />
        )}
        showState={showState}
        stateLabel={job.state_label}
        headerContext={job.job_type}
        statusChip={<StatusChipRenderer value={getJobStatusChipLabel(job)} extraClasses={getJobStatusColorClass(job).replaceAll("jobs", "status")} />}
        bodyTitle={job.service_name}
        bodySubtextPrimary={job.client_name}
        bodySubtextSecondary={job.service_location_address}
        bodyTags={<TagListRenderer tags={job.labels.map((label)=>label.name)} />}
        footerContextLabel={footerContext.label}
        footerContextValue={footerContext.value}
        footerPrimary={<UserAvatarStack users={job.assigned_technicians} limit={2} avatarSize={28} />}
    />
}

export default JobListCard;
